import { GraphAxisConfig, IGraphControl } from '@se/cp.common';
import { DataBinding } from '@se/se.platform.base';
import { CpModelService } from '../../cp-model.service';
import { rowProportional } from '../utils/utils';
import { CpControl } from './cp-control';

export class CpGraphControl extends CpControl {
    readonly controlTypeGroup = 'Graph';
    readonly dataBinding: DataBinding;
    readonly x: GraphAxisConfig;
    readonly y: GraphAxisConfig;

    constructor(control: IGraphControl, readonly context?: DataBinding) {
        super(control);

        const config = control.config[0];

        this.dataBinding = new DataBinding(config.dataBinding, context);
        this.x = config.x;
        this.y = config.y;
    }

    getModelObservable(modelService: CpModelService) {
        return modelService.registerList(this.dataBinding);
    }

    canAlignToBottom(): boolean {
        return false;
    }

    getHeightHint() {
        return rowProportional(this.rowSpan);
    }
}
